module.exports = __webpack_public_path__ + "static/media/AZUKI-ETH.bd9eb2e3.png";